import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import AppCard from 'components/app-card'
import SchoolOutlinedIcon from 'components/material-symbol/icons/School'
import headerImage from 'images/landing-coach-training-header.png'

const TRAINING_CENTER_URL =
  'https://vt.lightspeedvt.com/share/redirect.cfm?signInURL=https://webservices.lightspeedvt.net/SAML/lsvt/login.aspx?h=auth0.pga.com&dest=https://vt.lightspeedvt.com/trainingCenter/'

const useStyles = makeStyles({
  trainingBrand: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  trainingIconCircle: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 28, 87, 0.14)',
    color: '#001C57',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& .MuiSvgIcon-root': {
      fontSize: 22,
    },
  },
  trainingTitle: {
    fontFamily: '"Source Serif Pro", serif',
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.2,
    color: '#001C57',
  },
})

export default function CoachTraining() {
  const classes = useStyles()

  return (
    <AppCard
      title="Access courses, certifications, and coaching education."
      url={TRAINING_CENTER_URL}
      buttonText="Open Training Center"
      testid="coach-training-tile"
      headerImage={headerImage}
      headerImageAlt="Coach training center with laptop, books, and graduation cap"
      headerImagePosition="center 50%"
      brand={
        <Box className={classes.trainingBrand}>
          <span className={classes.trainingIconCircle}>
            <SchoolOutlinedIcon />
          </span>
          <Typography className={classes.trainingTitle} component="span">
            Training Center
          </Typography>
        </Box>
      }
    />
  )
}
